module.exports = __webpack_public_path__ + "assets/img/IMG011.6c702075.png";